import { DEFAULT_FORMATS } from '../../../shared/models/default-formats.const';

export const MIN_MAX_DATE_FORMAT = 'MM/DD/YYYY';
export const SERVER_TIME_FORMAT = DEFAULT_FORMATS.timeFormat;
export const COMMA = ',';
